
<template>
    <!--案件详情页面 -->
    <el-form label-width="180px" size="small">
    <el-collapse v-model="activeNames">
        <!-- 时间 -->
        <el-collapse-item name="1">
        <template slot="title">
            <h2 style="color:red">时间</h2>
        </template>
       
        <el-row>
                <el-col :span="6">
                    <el-form-item label="询价时间:">
                        <el-date-picker
                            style="width:100%"
                            v-model="dataForm.bidStartTime"
                            value-format="yyyy-MM-dd hh:mm:ss"
                            placeholder="请选择询价时间"
                            :disabled="true"
                            class="text-disabled"
                            type="datetime">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <!-- value-format="yyyy-MM-dd" -->
                    <el-form-item label="逾期时间:">
                        <el-date-picker
                        style="width:100%"
                        v-model="dataForm.bidEndTime"
                        placeholder="请选择逾期时间"
                        
                        :disabled="true"
                        class="text-disabled"
                        type="datetime">
                        </el-date-picker>
                    </el-form-item>  
                </el-col> 
        </el-row>
        </el-collapse-item>
           
        <!-- 基础信息 -->
        <el-collapse-item name="2">
            <template slot="title">
                <h2 style="color:red">基础信息</h2>
            </template>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="车辆编号:">
                        <el-input v-model="dataForm.vehicleSn" :disabled="true" class="text-disabled" placeholder="请输入车辆编号" >
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="报案号">
                        <el-input v-model="dataForm.caseSn" :disabled="true" class="text-disabled" placeholder="请输入报案号">
                        </el-input>
                    </el-form-item>   
                </el-col>
    
            </el-row>
    
            <!--  -->
            <el-row>
                <el-col :span="6">
                    <el-form-item label="保险公司">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.insurance.insureCompany" placeholder="请输入保险公司">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="分公司">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.insurance.insureFiliale" placeholder="请输入保险分公司">
    
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="分支机构">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.insurance.insureBranch" placeholder="请输入保险分机构">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
    
            <!--  -->
            <el-row>
                
                <el-col :span="6">
                    <el-form-item label="登记日期">
                        
                        <el-date-picker
                        style="width:100%"
                        :disabled="true"
                        class="text-disabled"
                        v-model="dataForm.factory.registerDate"
                        placeholder="请选择登记日期"
                        value-format="yyyy-MM-dd"
                        type="date">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="车架号">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.vin" placeholder="请输入车架号">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="车牌号">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.plateNo" placeholder="请输入车牌号">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                
                
                <el-col :span="6">
                    <el-form-item label="发动机号">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.engineNo" placeholder="请输入发动机号"> 
                        </el-input>
                    </el-form-item>   
                </el-col>
            
            </el-row>
    
            <el-row>
                <el-col :span="6">
                    <el-form-item label="车辆型号(品牌型号)">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.vehicleModel" placeholder="请输入车辆车型标志">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="车型">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.vehicleTradeName" placeholder="请输入车辆车型传播名">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="发票金额" >
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.invoiceValue">
                        </el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
    
            <!--  -->
            <el-row>
                <el-col :span="6">
                    <el-form-item label="车辆性质">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.useCharacter" placeholder="请输入车辆商用乘用">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="车辆停放地">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.vehicleParkingArea" placeholder="请输入车辆当前停放地" clearable>
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="所有人性质(车辆归属)">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.ownership" placeholder="请输入车辆的所属性质(公司/个人)">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
    
            <!--  -->
            <el-row>
                <el-col :span="6">
                    <el-form-item label="是否二手车">
                        <el-select 
                            style="width:100%"
                            :disabled="true" class="text-disabled" v-model="dataForm.current.blnTransfer" placeholder="是否二手车" clearable>
                            <el-option 
                                v-for="dict in dict.type.sys_yes_no"
                                :key="dict.value"
                                :label="dict.label"
                                :value="dict.value"
                            />
                        </el-select>
    
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="车辆类型">
                        <el-input >
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="发证日期">
                        
                        <el-date-picker
                            style="width:100%"
                            :disabled="true"
                            class="text-disabled"
                            v-model="dataForm.current.issueDate"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择询价时间"
                            type="date">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="公里数">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.vehicleKim">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="变速箱类型">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.gearboxType">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="排量">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.vehicleDisplacement">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <!-- <el-col :span="6">
                    <el-form-item label="乘用商用">
                        <el-input v-model="dataForm.current.passengerCommercial">
                        </el-input>
                    </el-form-item>
                </el-col> -->
            </el-row> 
    
            <el-row>
                <el-col :span="6">
                    <el-form-item label="保险金额">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.insureAmount">
                        </el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :span="6">
                    <el-form-item label="估损金额">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.damageCost">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="车损原因">
                        <el-input v-modle="dataForm.vehicleDamageReason">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="车辆种类(事故类型)">
                        <el-input>
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="出险日期">
                        <el-input>
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="报价有效期">
                        <el-input>
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="大票金额">
                        <el-input>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
    
            <el-row>
                <el-col :span="6">
                    <el-form-item label="实际价值(全损金额)">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.practicalValue">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <!-- <el-form-item label="定损员姓名">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.insurance.surveyorName">
                        </el-input>
                    </el-form-item> -->
                </el-col>
                <el-col :span="6">
                    <!-- <el-form-item label="定损员电话">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.insurance.surveyorPhone">
                        </el-input>
                    </el-form-item> -->
                </el-col>
            </el-row>
    
            <el-row>
                <el-col :span="6">
                    <el-form-item label="发动机是否完好">         
    
                              <el-select 
                                    :disabled="true"
                                  class="text-disabled" 
                                  v-model="dataForm.damage.engineGood" placeholder="发动机是否完好" clearable>
                                  <el-option 
                                      v-for="dict in dict.type.sys_yes_no"
                                      :key="dict.value"
                                      :label="dict.label"
                                      :value="dict.value"
                                  />
                              </el-select>
                     
                    </el-form-item>
                    
                </el-col>
                <!-- 备注 -->
                <el-col :span="6">
                    <el-form-item label="事故备注">
                        <textarea type="textarea"  :disabled="true" v-model="dataForm.vehicleAccidentRemark" >
    
                        </textarea>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-tag  effect="dark" type="danger" v-if="dataForm.offeringSecond=='Y'">二次询价车辆</el-tag>
                   
                </el-col>
            </el-row>
           
        </el-collapse-item>
        
        <!-- 二次报价原因 -->
        <el-collapse-item name="3">
            <template slot="title">
                <h2 style="color:red">二次报价原因</h2>
            </template>
            <el-row>
                <el-input :disabled="true" v-model="dataForm.offeringReason"  class="text-disabled" type="textarea">
                </el-input>
            </el-row>
        </el-collapse-item>


        <el-collapse-item title="二次报价附件" name="4">
            <template slot="title">
                <h2 style="color:red">二次报价附件</h2>
            </template>
            <el-row>
                <el-input :disabled="true" type="textarea">
                </el-input>
            </el-row>
        </el-collapse-item>
        <!--出险信息  -->
        <el-collapse-item  name="8">
                   
                   <template slot="title">
                       <h2 style="color:red">出险信息</h2>
                   </template>
                   <el-row>
                       <el-col :span="6">
                           <el-form-item label="责任认定">
                               <el-input class="text-disabled" :disabled="true" v-model="dataForm.damage.responsibility"  placeholder="请输入责任认定" >
                               </el-input>
                           </el-form-item>
                       </el-col>
    
                       <el-col :span="6">
                           <el-form-item label="车身电脑是否完整">
                               <el-select  
                                    style="width:100%"
                                    :disabled="true" class="text-disabled" v-model="dataForm.damage.vehicleEcu" placeholder="请选择车身电脑是否完好" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
    
                           
                       </el-col>
                       <el-col :span="6">
                           <el-form-item label="发动机电脑是否完好">
                               <el-select 
                                    style="width:100%"
                                    v-model="dataForm.damage.vehicleEcu"  :disabled="true" class="text-disabled" placeholder="请选择发动机电脑是否完好" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
                       </el-col>
    
                       <el-col :span="6">
                           <el-form-item label="发动机是否完好">
                               <el-select 
                                    style="width:100%"
                                    v-model="dataForm.damage.engineGood"  :disabled="true" class="text-disabled" placeholder="请选择发动机是否完好" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
                           
                       </el-col>
    
                       <el-col :span="6">    
                           <el-form-item label="是否脱审">
                               <el-select 
                                    style="width:100%"
                                    v-model="dataForm.damage.delisting"  :disabled="true" class="text-disabled" placeholder="请选择是否脱审" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
                           
                       </el-col>
    
                       <el-col :span="6">
                           <el-form-item label="人伤情况">
           
                               <el-input v-model="dataForm.damage.casualties"  :disabled="true" class="text-disabled" placeholder="请输入人伤情况" >
                               </el-input>
    
                           </el-form-item>
                           
                       </el-col>
                       <el-col :span="6">
                           <el-form-item label="天窗是否完好">
                               <el-select 
                                    style="width:100%"
                                    v-model="dataForm.damage.skylightGood"  :disabled="true" class="text-disabled" placeholder="请选择天窗是否完好" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
                           
                       </el-col>
                       <el-col :span="6">
                           <el-form-item label="是否拆解">
                               <el-select  
                                    style="width:100%"
                                    :disabled="true" v-model="dataForm.damage.assemble" class="text-disabled" placeholder="请选择是否拆解" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
                       </el-col>
    
                       
    
                       
    
                       <el-col :span="6">
                           <el-form-item label="变速箱完好">
                               
                               <el-select  
                                    style="width:100%"
                                    :disabled="true" v-model="dataForm.damage.gearboxGood" class="text-disabled" placeholder="请选择变速箱完好" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
    
                       </el-col>
    
                      
    
                       <el-col :span="6">
                           <el-form-item label="是否二次事故">
                               <el-select  
                                    style="width:100%"
                                    :disabled="true" v-model="dataForm.current.secondaryAccident" class="text-disabled" placeholder="请选择是否二次事故" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
                       </el-col>
                       
                       <el-col :span="6">
                           <el-form-item label="车辆大架号完好">
     
                               <el-select  
                                    style="width:100%"
                                    :disabled="true" v-model="dataForm.damage.steelSealNumber" class="text-disabled" placeholder="车辆大架号完好" clearable>
                                   <el-option 
                                       v-for="dict in dict.type.sys_yes_no"
                                       :key="dict.value"
                                       :label="dict.label"
                                       :value="dict.value"
                                   />
                               </el-select>
                           </el-form-item>
                       </el-col>
               </el-row>
        </el-collapse-item>
        
        <!-- 车辆图片 -->
        <el-collapse-item name="3">
            <template slot="title">
                <h2 style="color:red">车辆图片</h2>
            </template>
            <el-image 
                referrer-policy="no-referrer"
                style="width: 100px; height: 100px"
                v-for="urlItem in dataForm.damage.imgUrls" :key="urlItem" :src="urlItem"
                :preview-src-list="dataForm.damage.imgUrls">
            </el-image> 
        </el-collapse-item>
    
        <!-- 费用信息 -->
        <el-collapse-item name="4">
            <template slot="title">
                <h2 style="color:red">费用信息(由竞价单位承担)</h2>
            </template>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="停车费">
                        <el-input v-model="dataForm.cost.parkingFee">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="拆检费">
                        <el-input v-model="dataForm.cost.overhaulFee">
                        </el-input>
                    </el-form-item>
                </el-col>
    
                <el-col :span="6">
                    <el-form-item label="拖车费">
                        <el-input v-model="dataForm.cost.towingFee">
    
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="施救费">
                        <el-input v-model="dataForm.cost.salvageFee">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="其他费用">
                        <el-input v-model="dataForm.cost.otherFee">
                        </el-input> 
                    </el-form-item>
                </el-col>
            </el-row>       
        </el-collapse-item>
    
        <!-- 手续信息 -->
        <el-collapse-item name="5">
                    <template slot="title">
                        <h2 style="color:red">手续信息</h2>
                    </template>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="手续是否齐全">
                                <el-select v-model="dataForm.procedure.procedureComplete" placeholder="手续是否齐全">
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
    
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item label="是否抵押">
                                <el-select v-model="dataForm.procedure.mortgage" placeholder="是否抵押" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                                
                            </el-form-item>
                        </el-col>
    
                        <el-col :span="6" >
                            <el-form-item label="购置税本">
                                <el-select v-model="dataForm.procedure.purchaseTax" placeholder="是否有购置税本" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
    
                        <el-col :span="6" >
                            <el-form-item label="是否有贷款">
                                <el-select v-model="dataForm.procedure.loan" placeholder="是否有贷款" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
                            
                        </el-col>
                    </el-row>
    
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="组织机构代码证">
                                <el-select v-model="dataForm.procedure.organizationCodeCertificate" placeholder="是否有组织机构代码证" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="权益转让书">
                                <el-select v-model="dataForm.procedure.subrogationReceipt" placeholder="是否有权益转让书" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
    
    
                        <el-col :span="6">
                            <!-- <el-form-item label="破案证书">
                                <el-select  placeholder="是否有组织机构代码证" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item> -->
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="车主身份证复印件">
                                <el-select v-model="dataForm.procedure.idCardCopy" placeholder="是否有车主身份证复印件" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
            
                    <el-row>
                       
    
                        <el-col :span="6">
                            <el-form-item label="钥匙">
                                 <el-select v-model="dataForm.procedure.vehicleKey" placeholder="是否有钥匙" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
    
    
                        <el-col :span="6">
                            <el-form-item label="车牌">
                                
                                 <el-select v-model="dataForm.procedure.licencePlate" placeholder="是否有车牌" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select> 
                            </el-form-item>
                        </el-col>
    
                        <el-col :span="6">
                            <el-form-item label="行驶证">
                                <el-select v-model="dataForm.procedure.vehicleLicense" placeholder="是否有行驶证" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
    
                        <el-col :span="6">
                            <el-form-item label="登记证书">
                                <el-select v-model="dataForm.procedure.registrationCertificate" placeholder="是否有登记证书" clearable>
                                    <el-option 
                                        v-for="dict in dict.type.sys_yes_no"
                                        :key="dict.value"
                                        :label="dict.label"
                                        :value="dict.value"
                                    />
                                </el-select>
    
                                
                            </el-form-item>
                        </el-col>
                    </el-row>
                
        </el-collapse-item>
    
     
    </el-collapse>
    </el-form>
    </template>
    
    <script>
    
    import  MyVideoPlayer  from '@/components/VideoPlayer/index.vue';
 
    import {getCaseDetail} from '@/api/vehicle/quote';

    export default {
        name:'QuoteDetail',
        components:{MyVideoPlayer},
        dicts:['sys_yes_no'],

        created(){
            this.routerPath=this.$route.path;
            const caseId=this.$route.query.caseid;
            if(caseId){
                this.caseId=caseId;
                this.handleGetDetail(caseId);
            }
        },

        /**
        *  
        */
        beforeRouteEnter(to, from, next) {
            next(vm=>{
                if(to.query.caseid!=vm.caseId){
                    vm.caseId=to.query.caseid;
                    // 通过caseId 获取详情
                    vm.handleGetDetail(vm.caseId);
                    //vm.handleGetQuoteList(vm.caseId);
                }
            });
        },
        watch:{
            '$route'(newVal, oldVal) {
                // 当查询参数 myQuery 变化时，执行这里的代码 
               const caseId=newVal.query.caseid;
               const path=newVal.path;
               /**
                * 存在id caseId
                * 判断 this.routerPath，是否此本页面；(因为其他页面也会执行 watch);
                * CaseId 改变,才执行
                */
               if(caseId && path==this.routerPath && caseId!=this.caseId){
               
                }
            },
        },
        data(){
            return{
            routerPath:'',
            activeNames:['0','1','2','3','4','5','6','7','8','9','10'],
            caseId:'',
            dataForm:{
                bidStartTime:'',//询价时间(竞价开始)
                bidEndTime:'',//逾期时间(竞价结束)
                        
                vehicleSn:'', //车辆编号
                caseSn:'',//报案号
                vehicleParkingArea:'',//车辆停放地
    
                useCharacter:'',// 车辆使用性质
                vehicleDisplacement:'',//排量
                    
                accidentType:'',//事故类型
                insureAmount:'',//保险金额
                actualAmount:'',//实际金额
                damageCost:'',//估损金额
    
                //出厂信息
                factory:{
                    vin:'',//车架号
                    engineNo:'',//发动机号
                    registerDate:'',//登记(注册)日期
                    vehicleModel:'',//车辆型号(行车证)
                    vehicleTradeName:'',//车型型号；传播名
                    gearboxType:'',// 变速箱类型
                    vehicleDisplacement:'',//汽车排量
                    invoiceValue:'',//发票金额
                },
    
                //当前车辆信息
                current:{
                    plateNo:'',//车牌号
                    blnTransfer:'',//是否过户
                    vehicleKim:'',//公里数
                    issueDate:'',//发证日期
                    passengerCommercial:'',//乘用商用
                    practicalValue:'',//实际价值
                    ownership:'',//所有人性质
                },
                //车损信息
                damage:{
                    engineGood:'',//发动机是否完好
                    vehicleEcu:'',//车身电脑
                    engineEcu:'',//发动机电脑
                    responsibility:'',//责任认定
                    delisting:'',//是否脱审
                    casualties:'',//人员伤害
                    assemble:'',//是否拆解
                    imgUrls:[],//显示的图片列表
                
                },
    
                //保险公司信息
                insurance:{
                    insureCompany:'',// 保险公司
                    insureFiliale:'',// 保险分公司
                    insureBranch:'',// 分支机构
                    surveyorName:'', //定损员姓名
                    surveyorPhone:'',//定损员电话
                },
                // 费用信息
                cost:{
                    overhaulFee:'',//拆检费
                    otherFee:'',//其他费用
                    parkingFee:'',//停车费
                    salvageFee:'',//施救费
                    towingFee:'',//拖车费
                },
    
                //手续信息
                procedure:{
                    mortgage:'',//是否抵押
                    licencePlate:'',//车牌
                    loan:'',//是否有贷款
                    idCardCopy:'',//身份证复印件
                    organizationCodeCertificate:'',//组织机构代码证是否有
                    purchaseTax:'',//购置税本
                    registrationCertificate:'',//登记证书是否有
                    subrogationReceipt:'',//权益转让书
                    vehicleKey:'',//车钥匙
                    vehicleLicense:'',//行驶证
                },
    
                // 委托信息
                entrust:{
                    insuranceCompanyName:'',
                    insuranceCompanyPhone:'',
                    vehicleOwnerName:'',
                    vehicleOwnerPhone:'',
                    remark:'',
                },
                //入库信息
                storage:{
                    commitmentUrl:[],//委托协议
                    registrationUrl:[], //登记证书
                    drivingLicenseUrl:[],//驾驶证
                    identityCardUrl:[], //身份证
                    trafficScreenshotUrl:[],//交管截图
                    policyUrl:[],//保险单，
                    transferUrl:[],//过户视频
                    remark:'',
    
                }
            },
            //报价
            quoteForm:{
                bidNickName:'',
                bidUserId:'',
                finalPrice:'',
                remark:'',
            },
            blnSubmit:true,
         
            }
            
        },
        methods:{
            //显示素材详情
            handleGetDetail(caseId){
                // 获取详情
                getCaseDetail(caseId)
                .then(res=>{
                    if(res.data.entrust==null){
                        res.data.entrust=this.dataForm.entrust;
                    }
                    if(res.data.storage==null){
                        res.data.storage=this.dataForm.storage;
                    }
            
                    this.dataForm=res.data;
                    let data=this.dataForm.damage.imgUrls
                    if(!Array.isArray(data)){
                        this.dataForm.damage.imgUrls=JSON.parse(data);
                    }
                    data=this.dataForm.storage.commitmentUrl
                    if(!Array.isArray(data)){
                        this.dataForm.storage.commitmentUrl=JSON.parse(data);
                    }
                    
                    data=this.dataForm.storage.drivingLicenseUrl
                    if(!Array.isArray(data)){
                        this.dataForm.storage.drivingLicenseUrl=JSON.parse(data);
                    }
                    data=this.dataForm.storage.identityCardUrl    
                    if(!Array.isArray(data)){
                        this.dataForm.storage.identityCardUrl=JSON.parse(data);
                    }
        
                    data=this.dataForm.storage.policyUrl
                    if(!Array.isArray(data)){
                        this.dataForm.storage.policyUrl=JSON.parse(data);
                    }
                    data=this.dataForm.storage.registrationUrl
                    if(!Array.isArray(data)){
                        this.dataForm.storage.registrationUrl=JSON.parse(data);
                    }
                    data=this.dataForm.storage.trafficScreenshotUrl
                    if(!Array.isArray(data)){
                        this.dataForm.storage.trafficScreenshotUrl=JSON.parse(data);
                    }
                    data=this.dataForm.storage.transferUrl
                    if(!Array.isArray(data)){
                        this.dataForm.storage.transferUrl=JSON.parse(data);
                    }
                    
                
                })
                .catch(error=>{
                    console.log(error);
                })
            },
        }
    }
    </script>
    <style lang="scss" scoped>
    
    .text-disabled{
        -webkit-text-fill-color: #000502 !important; //修改输入框文字颜色
        // font-size: large;
        // font-weight: bolder;
    }
    
    </style>